
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import { Component, Vue } from "vue-property-decorator";
import NR, { CV } from "@/lib//model/NRXQ/nr";
import Auth from "@/lib/common/auth";
import vuexStore from "@/store/vuex-store";
import Cvtable from "@/views/nr/components/cvTable.vue";
import Upload from "@/views/nr/components/upload-cv.vue";
import AtsCv from "@/views/nr/components/ats-cv.vue";
import { NRClientType } from "@/lib/model/NRXQ/nr";

import MultiUploadCv from "@/views/nr/components/multi-upload-cv.vue";
@Component({
  components: { Cvtable, Upload, AtsCv, MultiUploadCv }
})
export default class ListNr extends Vue {
  nrToken = "";
  data: any = {}; //表格所有数据
  tableData: any = []; //表格list数据
  page = 1;
  pageSize = 10;
  showDia = false;
  searchPosition = "";
  searchName = "";
  showMultiAdd = false;
  formData: any = {}; //上传简历数据
  CvData: any = {}; //解析后简历数据
  showWarn = false;
  showSuccess = false;
  cvId = 0;
  showCV = false;
  clientType = NRClientType.NRClientTypeHR;
  rules = {
    position: [{ required: true, message: "请输入应聘职位", trigger: "blur" }]
  };

  created() {
    this.nrToken = String(localStorage.getItem("nrToken") || "");
    this.getList();
  }
  mounted() {
    //
  }
  async getList(flag?: string) {
    if (flag === "toPageOne") {
      this.page = 1;
    }
    await CV.list({
      page: this.page,
      pageSize: this.pageSize,
      atsUserToken: this.nrToken,
      showNameOrPhone: this.searchName,
      position: this.searchPosition
    }).then(res => {
      if (res.data.code !== 0) return;
      this.data = res.data.data;
      this.tableData = this.data.list;
    });
  }

  openUp() {
    this.showMultiAdd = true;
  }
  closeMultiCv() {
    this.showMultiAdd = false;
    this.getList();
  }

  showDetail(row: any) {
    this.cvId = row.atsCvId;
    this.showCV = true;
  }
  submit() {
    (this.$refs["form"] as any)?.validate(async (valid: any) => {
      if (valid) {
        //创建简历
        const p = this.CvData;
        p.atsUserToken = this.nrToken;
        p.position = this.formData.position;
        CV.saveCV(p).then(res => {
          this.$message.success("保存成功");
          this.close();
          this.getList();
        });
      }
    });
  }
  get beforeUpload() {
    return (
      this.formData.position !== "" && this.formData.position !== undefined
    );
  }
  //上传成功回调
  uploadSuccess(res: any) {
    this.showWarn = true;
    //解析简历
    CV.checkCV({
      resumeFileUrl: res.url,
      resumeFileName: res.filename,
      atsUserToken: this.nrToken
    }).then(res => {
      this.CvData = res;
      this.showSuccess = true;
      this.showWarn = false;
      this.$message.success("解析完成");
    });
  }

  close() {
    this.formData.name = "";
    this.showDia = false;
  }
}
